import Header from "./mainscreen/Header";
import Footer from "./mainscreen/footer/Footer";
import React, {useEffect, useState} from "react";
import {ISession} from "./networking/Options";
import {IB2CInfo, ICity, IFooter} from "./mainscreen/model/B2CInfo";
import {Modal} from "@material-ui/core";
import PromocodeActivationAlert from "./promocode/PromocodeActivationAlert";
import {useParams} from "react-router-dom";
import {localStorageKey} from "./mainscreen/items/promo/PromoItem";
import {openPassport} from "./mainscreen/header/Avatar";
import YandexProjectLogo from "./mainscreen/footer/YandexProjectLogo";
import FooterCopyright from "./mainscreen/footer/FooterCopyright";
import ContestPromo from "./mainscreen/ContestPromo";

export interface IMainScreenProps {
    session?: ISession
    city: ICity
    setCity: Function
    sections: JSX.Element[]
    isMobile: boolean
    isLight: boolean
    b2cInfo: IB2CInfo
}

export function MainScreenContainer(props: IMainScreenProps) {
    let session = props.session
    let city = props.city
    let footer = props.b2cInfo.footer
    let contest = props.b2cInfo.contest

    return <div className="MainScreenContainer">
        <Header
            avatarUrl={(session?.user.passport.avatar_url ?? "") + "/islands-68"}
            name={session?.user.passport.display_name ?? ""}
            city={city} onSelected={(c) => props.setCity(c)}
        />
        {props.sections}
        {contest != null &&
            <ContestPromo contest={contest} isMobile={props.isMobile} />
        }
        {!props.isLight && <Footer mobile={props.isMobile}
                                   footer={footer}
                                   city={city}
                                   cities={props.b2cInfo.cities}
                                   constants={props.b2cInfo.constants}
                                   onSelected={(c) => props.setCity(c)}
        />
        }
        <FooterCopyright/>
    </div>
}

interface IMainScreenContainerWithPromoProps {
    mainProps: IMainScreenProps
}

export function MainScreenContainerWithPromo(props: IMainScreenContainerWithPromoProps) {
    let {code} = useParams<{ code: string }>();

    const [showRegistrationAfterPromo, setShowRegistrationAfterPromo] = useState("false")
    const [openPromo, setOpenPromo] = useState(true);
    const handleOpenPromo = () => {
        setOpenPromo(true);
    };
    const handleClose = () => {
        setOpenPromo(false);
    };

    let mainProps = props.mainProps
    let session = props.mainProps.session

    useEffect(() => {
        handleOpenPromo()
    }, [])

    useEffect(() => {
        if (session == null) {
            openPassport()
        }
    }, [session])

    return <div>
        <MainScreenContainer {...mainProps} key={showRegistrationAfterPromo}/>
        {
            (session != null) && <Modal
                open={openPromo}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <PromocodeActivationAlert
                    onRegister={() => {
                        window.localStorage.setItem(localStorageKey, "true");
                        setOpenPromo(false);
                        setShowRegistrationAfterPromo("true")
                    }}
                    onClose={() => setOpenPromo(false)}
                    promocode={code}
                    session={session}
                    isMobile={props.mainProps.isMobile}
                />
            </Modal>
        }

    </div>
}